import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Price from '@max/leez-price';
import Text from '@max/leez-text';
import ExpiredTime from '../expired-time';
import Button from '../button';
import InflateLogo from '../inflate-logo';
import { getDescText, getPriceText } from '../../utils/coupon';
import './index.scss';
export default function MoreColCoupon(props) {
    const { isShowContainer, isSlider, updateCouponList, index, amountColor, couponData, currentTimeMillis, toastConfig, formatCouponConfigRes, setCurrentTimeMillis, location, bizLine, hotelchannel } = props || {};
    const { title = '', beginTime, status } = couponData || {};
    const componentStyle = {
        buttonStyle: {
            marginTop: '13rpx'
        },
        priceStyle: {
            marginTop: '5rpx',
            lineHeight: '50rpx',
            height: '50rpx'
        },
        whiteBg: {
            backgroundColor: '#FFF' // 设置底色，避免膨胀的logo与元素重合在一起
        },
        containerStyle: {
            width: isSlider ? '202rpx' : isShowContainer ? '218rpx' : '226rpx',
            marginLeft: index === 0 ? 0 : '12rpx'
        },
        expiredTimeStyle: {
            marginTop: '8rpx'
        }
    };
    return <View style={componentStyle.containerStyle} className="more-col-container">
      <InflateLogo type="default" status={status}/>
      <Text className="more-col-title" text={title.slice(0, 7)} type="title5" lineClamp={1}/>
      <View style={componentStyle.whiteBg}>
        <Price color={amountColor} content={getPriceText(couponData)} type="l2" showSymbol crossed={false} fontWeightType="bold" smallDecimal={true} style={componentStyle.priceStyle} symbolStyle={componentStyle.priceStyle} priceStyle={componentStyle.priceStyle}/>
      </View>
      <Text text={getDescText(couponData)} style={{
            height: '28rpx',
            marginTop: '4rpx'
        }} type="label2" color={amountColor} lineClamp={1}></Text>
      <Button location={location} updateCouponList={updateCouponList} index={index} formatCouponConfigRes={formatCouponConfigRes} toastConfig={toastConfig} couponData={couponData} currentTimeMillis={currentTimeMillis} setCurrentTimeMillis={setCurrentTimeMillis} beginTime={beginTime} style={componentStyle.buttonStyle} size="small" amountColor={amountColor} bizLine={bizLine} hotelchannel={hotelchannel}/>
      <ExpiredTime location={location} containerStyle={componentStyle.expiredTimeStyle} updateCouponList={updateCouponList} formatCouponConfigRes={formatCouponConfigRes} couponData={couponData} currentTimeMillis={currentTimeMillis} setCurrentTimeMillis={setCurrentTimeMillis}/>
    </View>;
}
